export interface TutorialVideo {
  /** Identifiant Vimeo de la vidéo. */
  id: string;
  title: string;
  /** Durée en secondes. */
  duration: number;
}

export type TutorialPage =
  | "dashboard"
  | "bailleur"
  | "biens"
  | "bien"
  | "locataires"
  | "locataire"
  | "locataire-paiements"
  | "banques"
  | "transactions";

export const HELP_CENTER_URL = "https://help.qalimo.fr";

export const TUTORIAL_PAGE_LABELS: Record<TutorialPage, string> = {
  dashboard: "Tableau de bord",
  bailleur: "Bailleur",
  biens: "Liste des biens",
  bien: "Bien",
  locataires: "Liste des locataires",
  locataire: "Locataire",
  "locataire-paiements": "Paiements",
  banques: "Mes banques",
  transactions: "Transactions",
};

export const TUTORIALS: Record<TutorialPage, TutorialVideo[]> = {
  dashboard: [
    { id: "1237937918", title: "Personnaliser ses documents", duration: 112 },
    {
      id: "1237937917",
      title: "Personnaliser les modèles d'email",
      duration: 116,
    },
    { id: "1237937867", title: "Gérer les automatisations", duration: 169 },
  ],
  bailleur: [
    { id: "1237937865", title: "La gestion du profil bailleur", duration: 299 },
    {
      id: "1237937919",
      title: "Partager la gestion de son compte",
      duration: 87,
    },
  ],
  biens: [
    { id: "1237937816", title: "Créer un bien", duration: 431 },
    { id: "1237937811", title: "Créer un immeuble", duration: 279 },
    { id: "1237937815", title: "Créer une colocation", duration: 220 },
  ],
  bien: [
    { id: "1237937868", title: "La gestion du bien immobilier", duration: 303 },
  ],
  locataires: [
    {
      id: "1237937754",
      title: "Comment créer un contrat de location",
      duration: 362,
    },
    {
      id: "1237937752",
      title: "Comment faire la reprise comptable d'un locataire",
      duration: 367,
    },
  ],
  locataire: [
    { id: "1237937864", title: "La fiche du locataire", duration: 423 },
    { id: "1237995317", title: "Refaire ou modifier le bail", duration: 138 },
    { id: "1237937753", title: "Comment inviter le locataire", duration: 60 },
    {
      id: "1237995316",
      title: "Réviser le loyer de son locataire",
      duration: 163,
    },
  ],
  "locataire-paiements": [
    {
      id: "1237995315",
      title: "Saisir un paiement en comptabilité",
      duration: 226,
    },
    {
      id: "1237937984",
      title: "Refacturer la taxe d'ordures ménagères",
      duration: 73,
    },
    { id: "1237937985", title: "Refacturer la taxe foncière", duration: 72 },
  ],
  banques: [
    {
      id: "1237937755",
      title: "Comment automatiser la comptabilité",
      duration: 308,
    },
    {
      id: "1237937784",
      title: "Créer des règles de répartition",
      duration: 192,
    },
  ],
  transactions: [
    {
      id: "1237995314",
      title: "Répartir un paiement en plusieurs opérations",
      duration: 132,
    },
    {
      id: "1237937920",
      title: "Mes opérations ne se synchronisent pas",
      duration: 263,
    },
  ],
};

/** "3:05" à partir d'une durée en secondes. */
export function formatDuration(seconds: number) {
  const minutes = Math.floor(seconds / 60);
  const rest = Math.floor(seconds % 60);
  return `${minutes}:${String(rest).padStart(2, "0")}`;
}
